import React, { ReactElement, useRef } from 'react';
import ContentLoader from 'react-content-loader';
import { Node } from '../../../Node';
import { useSkeletonColours } from '../../../../../../hooks/use-skeleton-colours';
import { DefaultTextNodeDisplay } from '../../../../Diagram/components/DiagramSideMenu/components/DiagramSideMenuButtonAddText/constants';
import styles from './DiagramTextSkeletonLoader.module.css';
import { usePosition } from './hooks/use-position';

export function DiagramTextSkeletonLoader(): ReactElement {
  const { backgroundColor, foregroundColor } = useSkeletonColours();
  const nodeRef = useRef<HTMLDivElement>(null);
  usePosition({
    display: {
      drawingType: DefaultTextNodeDisplay.drawingType,
      text: '',
      x: DefaultTextNodeDisplay.x,
      y: DefaultTextNodeDisplay.y,
    },
    nodeRef,
    uid: 'TEXT_SKELETON_LOADER',
  });
  return (
    <Node
      ref={nodeRef}
      uid="loader"
      isReadOnly={true}
      className={styles.skeletonLoader}
    >
      <ContentLoader
        className="half-margin-top"
        speed={0.7}
        width={40}
        height={30}
        backgroundColor={backgroundColor}
        foregroundColor={foregroundColor}
      >
        <rect x="0" y="0" width="40" height="30" />
      </ContentLoader>
    </Node>
  );
}
